export const StatusPaleBGPaletteLight: any = {
    1: '#DBF3FF',
    2: '#DBF3FF',
    3: '#DBF3FF',
    4: '#DBF3FF',
    5: '#D6F5DE',
    6: '#D6F5DE',
    7: '#FFE2E0',
    8: '#FEDDF8',
    9: '#FFEEE0',
    10: '#E8E1FE',
    11: '#E5E7EB',
    12: '#E5E7EB',
}
